module.exports = __webpack_public_path__ + "img/streaming_princess.88983dae.svg";